import { requiredUuidString } from '../zod-helpers/index.js';
/**
 * The GraphQL `ID` scalar validates nothing, so a malformed `partId` would otherwise reach
 * Postgres as a uuid predicate and fail the whole query with a 500 instead of a BAD_INPUT.
 */
export const partIdSchema = requiredUuidString('Part is required.', 'Invalid part selection.');
//# sourceMappingURL=part-id.js.map